import Api from './api.service';
export default {
  logUserActivity(data) {
    return Api().post('/user-activities', data);
  }
};
